import CourseImage1 from "../../../../assets/images/png/individual/courses/international/course1.webp";
import CourseImage2 from "../../../../assets/images/png/individual/courses/international/course2.webp";
import CourseImage3 from "../../../../assets/images/png/individual/courses/international/course3.webp";
import CourseImage4 from "../../../../assets/images/png/individual/courses/international/course4.webp";

const learningDataEurope = [
  {
    id: 1,
    image: CourseImage1,
    title: "Data Science Bootcamp (Europe)",
    url: "/courses/data-science-bootcamp",
    courseType: "For Data Enthusiast",
    courseLevel: "6 Months",
  },
  {
    id: 2,
    image: CourseImage3,
    title: "Product Management Bootcamp (Europe)",
    url: "/courses/product-management-and-design-bootcamp",
    courseType: "For Professionals",
    courseLevel: "12 Weeks",
  },
  {
    id: 3,
    image: CourseImage4,
    title: "Business Analysis Bootcamp (Europe)",
    url: "/courses/business-analysis-bootcamp",
    courseType: "For Professionals",
    courseLevel: "12 Weeks",
  },
  {
    id: 4,
    image: CourseImage2,
    title: "Cloud Bootcamp (Europe)",
    url: "/courses/cloud-bootcamp",
    courseType: "For Early Professionals",
    courseLevel: "16 Weeks",
  },
];

export default learningDataEurope;
